<template>
  <a-modal :title="title" :width="1000" :visible="visible" :confirmLoading="confirmLoading"
    :maskClosable="false" :body-style="{ height: '480px', overflow: 'hidden', overflowY: 'scroll' }"
    @cancel="handleCancel" :okText="$t('确定')" :cancelText="$t('关闭')" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }">
    <a-spin :spinning="confirmLoading">
      <j-form-container :disabled="formDisabled">
        <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false">
            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-model-item :label="$t('是否排水')" prop="isDrain">
                  <a-radio-group v-model="model.isDrain">
                    <a-radio :value="1">{{ $t('是') }}</a-radio>
                    <a-radio :value="0">{{ $t('否') }}</a-radio>
                  </a-radio-group>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item :label="$t('报装口径')" prop="caliberReport">
                  <a-input-number v-model="model.caliberReport" :placeholder="$t('请输入报装口径')" style="width: 100%" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item :label="$t('管线长度及规格(米)')" prop="pipelineLengthSpecifications">
                  <a-input-number v-model="model.pipelineLengthSpecifications" :placeholder="$t('请输入管线长度及规格')" style="width: 100%" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item :label="$t('工程预算(元)')" prop="projectBudget">
                  <a-input-number v-model="model.projectBudget" :placeholder="$t('请输入工程预算')" style="width: 100%" />
                </a-form-model-item>
              </a-col>
              <a-col :span="24">
                <a-form-model-item :label="$t('备注信息')" prop="remark">
                  <a-textarea v-model="model.remark" :placeholder="$t('请输入备注信息')" :rows="4" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item :label="$t('附件')" prop="annex">
                  <!-- <a-upload name="file" :multiple="false" :fileList="fileList" :beforeUpload="beforeUpload" :remove="handleRemove" @change="handleChange">
                      <a-button>
                          <a-icon type="upload" />
                          选择附件
                      </a-button>
                  </a-upload> -->
                  <JUpload v-model="fileList" :buttonVisible="false"/>
                </a-form-model-item>
              </a-col>
            </a-row>
        </a-form-model>
      </j-form-container>
    </a-spin>
  </a-modal>
</template>

<script>
  import { validateDuplicateValue,historyFileUrl } from '@/utils/util'
  import JUpload from '@/components/jeecg/JUpload'
  export default{
    components:{
      JUpload
    },
    data() {
      return {
        title: '',
        visible: false,
        disableSubmit: false,
        model: {},
        confirmLoading: false,
        validatorRules: {},
        url: {},
        fileList: []
      }
    },
    computed: {
      formDisabled() {
        return this.disableSubmit
      },
    },
    created() {},
    methods:{
      init(row,type){
        this.visible = true;
        this.model = JSON.parse(JSON.stringify(row));
        if (this.model.annex == null) {
          this.fileList = []
        } else {
          // this.fileList = [
          //   {
          //     uid: '1',
          //     name: this.model.annex,
          //     status: 'done ',
          //     linkProps: '{"download": "image"}', // 下载链接额外的 HTML 属性
          //     url: historyFileUrl + '/' + this.model.annex,
          //   },
          // ]
          this.fileList = [this.model.annex];
        }
        if(type == 'detail'){
          this.disableSubmit = true;
          this.title = this.$t('详情');
        }else{
          this.disableSubmit = false;
          if(this.model.id){
            this.title = this.$t('编辑');
          }else{
            this.title = this.$t('新增');
          }
        }
      },
      handleCancel() {
        this.close()
      },
      close() {
        this.$emit('close');
        this.visible = false;
        this.disableSubmit = false;
      },
    }
  }
</script>

<style>
</style>